import useSelector from '@app/hooks/useSelector';

import { getTags } from '../../../../reducers/downloadData/selectors';
import TagsInput from './TagsInput';

const prepareIncomingValue = (value: string) =>
    value
        .split(',')
        .filter((tag) => tag !== '')
        .map((tag) => ({ value: tag, label: tag }));

const prepareOutgoingValue = (value: readonly { value: string; label: string }[]) =>
    value.map((item) => item.value).join(',');

interface TagsInputContainerProps {
    value: string;
    label: string;
    hint: string;
    onChange: (value: string) => void;
}

const TagsInputContainer = ({ value, label, hint, onChange }: TagsInputContainerProps) => {
    const tags = useSelector(getTags);

    return (
        <TagsInput
            label={label}
            value={prepareIncomingValue(value)}
            options={tags.map((tag) => ({ value: tag, label: tag }))}
            hint={hint}
            onChange={(val) => onChange(prepareOutgoingValue(val))}
        />
    );
};

export default TagsInputContainer;
